import React, { FunctionComponent } from 'react';
import type { CoverShowComponentProps, RecruitmentImage } from '../../../types/recruitments';
import classnames from 'classnames';

type Props = CoverShowComponentProps & {
  displayImages: RecruitmentImage[];
  currentIndex: number;
  handleSubImageClick: (index: number) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  images,
  recruitmentTitle,
  noimage,
  isScouted,
  isApplied,
  displayImages,
  currentIndex,
  isNew,
  regularEmployee,
  handleSubImageClick,
}) => {
  return (
    <section className="recruitment__show__heading recruitment__show__heading--thumbs">
      <div className={classnames('recruitment__show__heading__gallery', { 'is-single': displayImages.length === 1 })}>
        {/* メイン画像 */}
        <div className="recruitment__show__heading__slider-viewport">
          <div
            className="recruitment__show__heading__slider-track"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {displayImages.map((img, idx) => (
              <img
                key={img.id ?? idx}
                src={img.url}
                className="recruitment__show__heading__main-img"
                alt={recruitmentTitle + 'のカバー写真'}
              />
            ))}
          </div>
        </div>
        <div className="status_panel">
          {isNew &&
            <span className="is_tag">
              新着
            </span>
          }
          {regularEmployee &&
            <span className="is_tag">
              正社員
            </span>
          }
          {isScouted &&
            <span className="is_tag">
              スカウトあり
            </span>
          }
          {isApplied &&
            <span className="is_tag">
              エントリー済み
            </span>
          }
        </div>
        {/* サムネ */}
        {displayImages.length > 1 && (
          <div className="recruitment__show__heading__thumbs is-slider">
            {displayImages.map((img, idx) => (
              <button
                key={img.id ?? idx}
                type="button"
                className="recruitment__show__heading__thumb"
                onClick={() => handleSubImageClick(idx)}
              >
                <img src={img.url} alt="" />
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
